module.exports = __webpack_public_path__ + "packs/media/images/Spot-f9b78e41337740f92f733b35e9af19c1.svg";